import React from 'react';
import PropTypes from 'prop-types';

export default function HealthInsuranceIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16.688 15.292'
      className={className}
    >
      <g id='Grupo_12323' data-name='Grupo 12323' transform='translate(-327 -326)'>
        <rect
          id='Retângulo_1252'
          data-name='Retângulo 1252'
          width='1.766'
          height='1.766'
          transform='translate(333.749 329.901)'
          fill={fill}
        />
        <path
          id='Caminho_11896'
          data-name='Caminho 11896'
          d='M1228.448,561.6v5.7H1225.6v7.632a1.969,1.969,0,0,0,1.965,1.965h12.758a1.969,1.969,0,0,0,1.965-1.965V561.6Zm0,12.615h-1.054v-5.866h1.054Zm2.848-9.768h3.9v3.9h-3.9Zm0,5.667h2.478v1.054H1231.3Zm8.144,3.9h-8.173v-1.054h8.173Zm0-2.819h-3.9v-1.054h3.9Zm0-2.848h-2.477V567.3h2.477Zm0-2.848h-2.477v-1.054h2.477Z'
          transform='translate(-898.6 -235.6)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

HealthInsuranceIcon.defaultProps = {
  fill: '#cacaca',
  width: 16.688,
  height: 15.292
};

HealthInsuranceIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
